import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { auth } from "../../firebaseConfig";

const readDataS3 = async () => {
  const user = auth.currentUser;
  try {
    const docRef1 = doc(
      db,
      "Advisers",
      user.uid,
      "Application Details",
      "Life Assurance Companies"
    );
    const docRef2 = doc(
      db,
      "Advisers",
      user.uid,
      "Application Details",
      "Work History"
    );
    const docSnap1 = await getDoc(docRef1);
    const docSnap2 = await getDoc(docRef2);

    if (docSnap1.exists() && docSnap2.exists()) {
        return {
            lifeAssuranceCompanies: docSnap1.data(),
            workHistory: docSnap2.data(),
        };

    } else {
      // console.log("No such document for Section 3!");
      return null;
    }
  } catch (error) {
    // console.error("Error fetching Section 3 data: ", error);
    return null;
  }
};

export default readDataS3;
